import React from 'react';
import NextLink from 'next/link';
import dynamic from 'next/dynamic';
import { Box, Container, Typography } from '@mui/material';
import { COLOR_PURPLE } from 'styles/variables/colors';
import HeaderInformation from '../HeaderInformation';
import InstitutionsCommunication from 'components/InstitutionsCommunication';
import CustomButton from 'components/CustomButton';
import { useStyles } from './styles';

const DynamicBuildPresentations = dynamic(() => import('components/BuildPresentations'));
const DynamicPharmaceuticalCompanies = dynamic(() => import('components/PharmaceuticalCompanies'));
const DynamicPublishedSection = dynamic(() => import('components/PublishedSection'));
const DynamicReferToAcademicInstitution = dynamic(() =>
  import('components/ReferToAcademicInstitution'),
);
const DynamicCreatingScienceIllustrations = dynamic(() =>
  import('components/CreatingScienceIllustrations'),
);

export default function PharmasContent() {
  const classes = useStyles();

  return (
    <>
      <Box py={3} bgcolor={COLOR_PURPLE} height={239}>
        <Container>
          <HeaderInformation
            marginLeftPercentage={51.5}
            textTitle={
              <>
                For Pharmaceuticals <br /> & Biotechs
              </>
            }
            textDescription={
              <>
                Get in touch with our team to learn more about how <br />
                Mind the Graph can assist you to save countless work <br />
                hours. View some of our use cases in which other <br />
                pharmaceuticals are already communicating science <br />
                professionally.
              </>
            }
          />
        </Container>
      </Box>

      <InstitutionsCommunication
        textTitle={
          <>
            The best infographic maker for <br /> communicating science visually
          </>
        }
        textInformation={
          <>
            Go straight to the point with Professional & Visually Appealing <br />
            infographics for science communication. Browse through 75,000+ <br />
            scientifically-accurate illustrations in more than 80 study fields.
          </>
        }
        textButton="Get More Professional"
      />

      <DynamicPharmaceuticalCompanies />

      <Box bgcolor="#FFFFFF" py={6}>
        <DynamicCreatingScienceIllustrations
          textTitle="Supplying your sales force with the most accurate science diagrams"
          textDescription={
            <>
              When it comes to science communication, an image can really be worth a Thousand words.
              Sometimes <br /> even more. Investing in scientifically-accurate illustrations is
              essential forsetting the right tone for a <br /> good science-business conversation.
              After all, scientists know the difference between a rat and a <br /> mouse just by
              looking.
            </>
          }
        />

        <Box textAlign="center" pt={2}>
          <NextLink href={`/institutions/book-a-demo`} passHref={true}>
            <CustomButton>Book a Demo</CustomButton>
          </NextLink>
        </Box>
      </Box>

      <DynamicBuildPresentations />

      <Box>
        <Box pt={5}>
          <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
            <b>Mind the Graph has been cited in many journals worldwide</b>
          </Typography>
        </Box>

        <DynamicPublishedSection showTitle={false} />
      </Box>

      <DynamicReferToAcademicInstitution
        textTitle="Refer Mind the Graph to a Pharma or Biotech company"
        textSubtitle={
          <>
            Refer the best science infographic maker as <br />
            an exclusive benefit to all associates
          </>
        }
        textInformation={
          <>
            Insert the person in charge's email <br />
            below and we'll get in touch
          </>
        }
      />
    </>
  );
}
